
import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import './AboutUs.css';
import OurValues from './Images/OurValues.png';
import OurVision from './Images/OurVision.png';
import OurMission from './Images/OurMission.png';
import img3 from './Images/img3.jpg';
import img9 from './Images/img9.jpg';
import { Link } from 'react-router-dom';
import TeamSection from './TeamSection';
import { FiCheckCircle } from "react-icons/fi"; // Blue check icon



const ApiProductList = () => {

    const location = useLocation();
    const missionRef = useRef(null);
    const leadershipRef = useRef(null);

    useEffect(() => {
        const target = location.state?.scrollTo;
        if (target === 'mission' && missionRef.current) {
            missionRef.current.scrollIntoView({ behavior: 'smooth' });
        } else if (target === 'leadership' && leadershipRef.current) {
            leadershipRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [location]);


    return (
        <div>

         <div className='fullcolordiv'>
                <h2 className='aboutpageheading'> About Global Link Corporation (GLC) </h2>
                <p className='aboutpageparagraph'>Global Link Corporation (GLC) is a trusted pharmaceutical export and import company, delivering high-quality healthcare products globally with a 
                    commitment to excellence and regulatory compliance.</p>
         </div>




            <div className="company-container">
                <div className="company-text">
                    <h2>Our Company</h2>
                    <p>
                        Welcome to Global Link Corporation (GLC), a trusted leader in the chemical distribution and manufacturing 
                        industry. With decades of expertise, we provide comprehensive solutions that cater to a wide range of
                         industries across the globe. Our relentless pursuit of innovation and excellence drives us to deliver
                          unparalleled value at every stage of the supply chain.
                    </p>
                    <p>
                        At GLC, we combine technical proficiency with strategic market insights to craft customized solutions that 
                        perfectly align with our clients’ unique needs. Our deep understanding of the industry and commitment to 
                        quality have established us as a reliable partner in chemical solutions.
                    </p>
                   

                    {/* ✅ Certifications with blue icons */}
                    <div className="company-certifications">
                        <ul>
                            <li className="certification-item">
                                <FiCheckCircle className="blue-check-icon" />
                                Certified pharmaceutical-grade products
                            </li>
                            <li className="certification-item">
                                <FiCheckCircle className="blue-check-icon" />
                                Seamless multi-industry production support
                            </li>
                        </ul>
                        <ul>
                            <li className="certification-item">
                                <FiCheckCircle className="blue-check-icon" />
                                Durable, sustainable packaging
                            </li>
                            <li className="certification-item">
                                <FiCheckCircle className="blue-check-icon" />
                                Customized solutions for efficient operations
                            </li>
                        </ul>
                    </div>
                </div>

                {/* 🔄 Image Slider */}
                <div className="company-image">
                    <div className="slide-track">
                        <img src={img3} alt="Company 1" className="slide" />
                        <img src={img9} alt="Company 2" className="slide" />
                    </div>
                </div>
            </div>
            <div className='MissionVisionValues' ref={missionRef} id="mission">
            <div className='OurMissionCenter'>
                <h3 className='OurMissionHeading'> Our Mission & Vision & Values</h3>
                    <p className='urMissionParagraph'>Driving Innovation and Excellence in Global Chemical Solutions</p>
            </div>

            <div className='mission'>
                <div className='box'>
                    <div className='boxImage'>
                        <div className='imghome'>
                            <img src={OurMission} alt='logo' />
                        </div>
                        <div>
                            <div className='UnderlineBelowImage'></div>
                            <h3> Our Mission</h3>
                            <p className="pp">
                                    At Global Link Corporation, our mission is to be a trusted bridge between quality and innovation in the chemical and pharmaceutical industry. We are committed to delivering high-grade raw materials, building long-term, ethical partnerships, and supporting our clients’ growth through reliable sourcing and transparent service.
                            </p>
                        </div>
                    </div>
                </div>

                <div className='box'>
                    <div className='boxImage'>
                        <div className='imghome'>
                                <img src={OurValues} alt='homelogo' />
                        </div>
                        <div>
                            <div className='UnderlineBelowImage'></div>
                            <h3> Our Vision</h3>
                            <p className="pp">
                                    To become a globally recognized trading partner driven by trust, integrity, and long-lasting relationships — connecting industries across borders with knowledge, quality, and commitment. Entrepreneurial spirit and customer-first thinking will continue to guide our growth and impact.
                            </p>
                        </div>
                    </div>
                </div>

                <div className='box'>
                    <div className='boxImage'>
                        <div className='imghome'>
                                <img src={OurVision} alt='jome logo' />
                        </div>
                        <div>
                            <div className='UnderlineBelowImage'></div>
                            <h3> Our Values</h3>
                            <p className="pp">
                                    At Global Link Corporation, our values guide every decision and partnership. We believe in collaboration, mutual respect, accountability, and building lasting relationships. These principles shape how we work, ensuring integrity, transparency, and long-term success in everything we do.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
         </div>
             

            <div ref={leadershipRef} id="leadership" >
                <TeamSection />
            </div>


            <div className='fullcolordiv1'>
                <h2 className='aboutpageheading'>Ready to Work With Us? </h2>
                <p className='aboutpageparagraph'>Contact us today to discuss how our products and services can benefit your business.</p>
                <Link to="/contact" state={{ scrollTo: "form" }}>
                <button className="aboutpage-button">Contact Us Now</button>
            </Link>
            </div>


        </div>
    );
};

export default ApiProductList;
